import { render, staticRenderFns } from "./component-f84d9a52.vue?vue&type=template&id=524badb0&scoped=true&"
import script from "./component-f84d9a52.vue?vue&type=script&lang=js&"
export * from "./component-f84d9a52.vue?vue&type=script&lang=js&"
import style0 from "./component-f84d9a52.vue?vue&type=style&index=0&id=524badb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524badb0",
  null
  
)

export default component.exports